

    /**
     * Safer Object.hasOwnProperty
     */
     function hasOwn(obj, prop){
         return Object.prototype.hasOwnProperty.call(obj, prop);
     }

     module.exports = hasOwn;





//////////////////
// WEBPACK FOOTER
// ./~/mout/object/hasOwn.js
// module id = 157
// module chunks = 0 1 2